"use client";

import { css } from "@/../styled-system/css";

import NewsLetterSubscribeFormNoAction from "./NewsLetterSubscribeFormNoAction";

const newsletterContainerClass = css({
  display: "block",
  md: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "5",
  },
});

const newsletterHeaderCSS = css({
  fontSize: "2rem",
  color: "white",
  fontWeight: "semibold",
  lineHeight: "none",
  mb: "4",
  fontFamily: "inter",
});

function FooterNewsletter() {
  return (
    <div className={newsletterContainerClass}>
      <div
        className={css({
          width: "100%",
          mb: "5",
          md: {
            mb: "0",
          },
        })}
      >
        <h2 className={newsletterHeaderCSS}>Join our newsletter</h2>
        <div>
          <span
            className={css({
              fontSize: "md",
              color: "gray.100",
              fontFamily: "inter",
            })}
          >
            We’ll send you a nice letter once per week. No spam.
          </span>
        </div>
      </div>
      <NewsLetterSubscribeFormNoAction />
    </div>
  );
}

export default FooterNewsletter;
